import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MailFile } from 'src/app/shared/models/mails/mail-file';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileSelectEvent } from 'primeng/fileupload';

@Component({
  selector: 'app-email-file-select-modal',
  templateUrl: './email-file-select-modal.component.html',
  styleUrls: ['./email-file-select-modal.component.scss'],
})
export class EmailFileSelectModalComponent implements OnInit {
  public mailFiles: MailFile[];
  public mailFilesLV: { label: string; value: MailFile }[] = [];
  public selectedMailFiles: MailFile[];
  public form = new UntypedFormGroup({
    fileSelect: new UntypedFormControl(null),
  });
  public staticFiles: File[] = [];
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  public onUploadClick(): void {
    document.getElementsByClassName('fileUploadCustom')[0].querySelector('input').click();
  }

  ngOnInit(): void {
    if (this.config?.data) {
      this.mailFiles = this.config.data.mailFiles;
      this.selectedMailFiles = this.config.data.selectedMailFiles;
    }

    const selectedFiles = [];
    this.mailFiles.forEach((m) => {
      this.mailFilesLV.push({ label: m.description, value: m });
    });

    this.mailFilesLV.forEach((f) => {
      this.selectedMailFiles.forEach((selected) => {
        if (f.value.id === selected.id) {
          selectedFiles.push(f.value);
        }
      });
    });

    this.form.patchValue({
      fileSelect: selectedFiles,
    });
  }

  submit(): void {
    this.ref.close({ form: this.form.value.fileSelect, staticFiles: this.staticFiles });
  }

  onSelectFiles(event: FileSelectEvent): void {
    this.staticFiles = event.currentFiles;
  }
}
